import SidebarItem from '@/components/SidebarItem/SidebarItem';

export default SidebarItem;
